import { Divider, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LatePaymentPenaltyRateMentionsGroup } from './elements/LatePaymentPenaltyRateMentionsGroup'

export const LegalMentionsLatePaymentsPenaltyRate = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Text>
        {t('settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.description')}
      </Text>
      <Divider />
      <LatePaymentPenaltyRateMentionsGroup />
    </Flex>
  )
}
